import Cookies from 'js-cookie';

const HubCookie = function () {
    const cookieName = '__hubt';
    const fn = 'firstName';
    const ln = 'lastName';
    const tk = 'token';
    let cookieData = {};

    const init = () => {
        parse();
    };

    const parse = () => {
        cookieData = Cookies.getJSON(cookieName) || {};
    };

    this.set = (data, config) => {
        config = config || {};
        const setup = {};
        setup.expires = config.expires || 7;
        setup.expires = Number(setup.expires);
        setup.secure = window.location.protocol === 'https:';
        Cookies.set(cookieName, data, setup);
    }

    this.unset = () => {
        Cookies.remove(cookieName);
    };

    this.exists = () => {
        parse();
        if (!cookieData[fn] || !cookieData[tk]) {
            return false;
        }
        return true;
    };

    this.getFirstName = () => {
        parse();
        return cookieData[fn];
    };

    this.getLastName = () => {
        parse();
        return cookieData[ln];
    };

    this.getToken = () => {
        parse();
        return cookieData[tk];
    };

    init();
};

export { HubCookie };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/HubCookie.js